<template>
  <a-row class="container-fluid container-wrap col-sm-12 col-xs-12">
    <a-col :span="1"></a-col>
    <a-col class="justify-content-center" :span="22">
      <div style="margin-top: 28px"></div>
      <div class="card-header pb-0 col-sm-12 d-flex">
        <div class="col-sm-12 col-xs-12">
          <div class="col-sm-12 col-xs-12 justify-content-between titleContainer">
            <h3 class="title">센터플로우 구독 관리</h3>
            <h5 class="desc">센터플로우 구독을 관리하고 조회할 수 있습니다.</h5>
          </div>
        </div>
      </div>
      
      <!-- 검색 및 필터 영역 -->
      <div class="card-body px-0 pt-0 pb-2 table-with-search">
        <div class="search-filter-container table-info-filter">
          <div class="search-filter-row">
            <div class="search-filter-title">
              병원명
            </div>
            <div class="search-filter-content">
              <div class="mobile-wrap">
                <a-input v-model:value="searchParams.hospitalName" placeholder="병원명을 입력하세요" size="small" />
              </div>
            </div>
          </div>
          <div class="search-filter-row">
            <div class="search-filter-title">
              상태
            </div>
            <div class="search-filter-content">
              <a-select v-model:value="searchParams.status" style="width: 150px" size="small">
                <a-select-option value="">전체</a-select-option>
                <a-select-option value="ACTIVE">활성</a-select-option>
                <a-select-option value="EXPIRED">만료</a-select-option>
                <a-select-option value="PENDING">대기</a-select-option>
                <a-select-option value="CANCELED">취소</a-select-option>
                <a-select-option value="SUSPENDED">정지</a-select-option>
              </a-select>
            </div>
          </div>
          <div class="search-filter-row">
            <div class="search-filter-title">
              병원 유형
            </div>
            <div class="search-filter-content">
              <a-select v-model:value="searchParams.hospitalType" style="width: 150px" size="small">
                <a-select-option value="">전체</a-select-option>
                <a-select-option value="DENT">치과</a-select-option>
                <a-select-option value="OS">정형외과</a-select-option>
                <a-select-option value="OPH">안과</a-select-option>
              </a-select>
            </div>
          </div>
          <div class="search-filter-row">
            <div class="search-filter-title">
              계약 기간
            </div>
            <div class="search-filter-content">
              <div class="date-range-picker">
                <a-range-picker 
                  v-model:value="dateRange"
                  format="YYYY-MM-DD"
                  :placeholder="['시작일', '종료일']"
                  size="small"
                />
              </div>
            </div>
          </div>
          <div class="search-filter-row">
            <div class="search-filter-content">
              <div class="mobile-wrap">
                <button
                  class="search-btn-filter"
                  @click="searchSubscriptions"
                >
                  검색
                </button>
                <button
                  class="init-btn"
                  @click="resetSearch"
                >
                  초기화
                </button>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-xs-12 table-info-filter">
          <div class="total-div">
            <p>
              전체
              <span class="number-highlight">{{ totalItems }}</span>
              건
            </p>
          </div>
          <div class="search-container">
            <a-select class="search-select" v-model:value="pageSize" style="width: 120px"
                      @change="handlePageSizeChange">
              <a-select-option :value="10">10개씩 보기</a-select-option>
              <a-select-option :value="20">20개씩 보기</a-select-option>
              <a-select-option :value="50">50개씩 보기</a-select-option>
            </a-select>
          </div>
        </div>
        
        <div class="card content-wrap-card col-sm-12 col-xs-12 tableCard p-0">
          <div class="table-responsive table-wrap table-relative">
            <div class="table-spinner-container" v-if="loading">
              <div class="spinner" />
            </div>
            <a-table 
              class="ant-table-striped"
              size="small"
              bordered
              :loading="loading"
              :scroll="{ x: '1200px' }"
              :columns="columns"
              :data-source="subscriptionList"
              :pagination="false"
              v-show="!loading && subscriptionList.length > 0"
            >
              <template #emptyText>
                <div class="no-result-container">
                  <i class="fa-solid fa-exclamation-triangle" style="font-size: 24px; margin-bottom: 10px"/><br>
                  <span>등록된 구독이 없습니다.</span>
                </div>
              </template>
              
              <!-- 셀 커스텀 렌더링 -->
              <template #bodyCell="{ column, text, record }">
                <!-- 상태 표시 -->
                <template v-if="column.dataIndex === 'status'">
                  <a-tag :color="getStatusColor(text)">{{ getStatusText(text) }}</a-tag>
                </template>
                
                <!-- 금액 표시 -->
                <template v-if="column.dataIndex === 'price' || column.dataIndex === 'priceExcludingVAT' || column.dataIndex === 'priceIncludingVAT'">
                  {{ text?.toLocaleString() || '0' }}원
                </template>
                
                <!-- 날짜 표시 -->
                <template v-if="column.dataIndex === 'contractStartDate'">
                  <div class="date-with-button">
                    <div>{{ formatDate(text) }}</div>
                    <div class="button-cell-container">
                      <a-button 
                        size="small" 
                        class="day-calc-btn"
                        @click="handleDayCalculation(record)"
                      >
                        첫회차 일할 계산 보기
                      </a-button>
                    </div>
                  </div>
                </template>
                <template v-if="column.dataIndex === 'contractEndDate'">
                  {{ formatDate(text) }}
                </template>
                
                <!-- 병원 유형 표시 -->
                <template v-if="column.dataIndex === 'hospitalType'">
                  {{ getHospitalTypeText(text) }}
                </template>
                
                <!-- 연락처 표시 -->
                <template v-if="column.dataIndex === 'managerContact'">
                  {{ formatMobileNumber(text) }}
                </template>
                
                <!-- 결제 예정일 표시 -->
                <template v-if="column.dataIndex === 'paymentDueDate'">
                  매월 5 일
                </template>
                
                <!-- 결제카드 표시 -->
                <template v-if="column.dataIndex === 'paymentCard'">
                  <div class="card-manage-container">
                    <span class="card-company">{{ getActiveCardCompany(record) }}</span>
                    <div class="button-cell-container">
                      <a-button 
                        size="small" 
                        class="card-manage-btn" 
                        @click="handleManageCard(record)"
                      >
                        카드관리
                      </a-button>
                    </div>
                  </div>
                </template>
                
                <!-- 결제내역 표시 -->
                <template v-if="column.dataIndex === 'paymentHistory'">
                  <div class="button-cell-container">
                    <a-button 
                      size="small" 
                      class="payment-history-btn" 
                      @click="handleViewPaymentHistory(record)"
                    >
                      보기
                    </a-button>
                  </div>
                </template>
                
                <!-- 결제하기 표시 -->
                <template v-if="column.dataIndex === 'makePayment'">
                  <div class="button-cell-container">
                    <a-button 
                      size="small" 
                      class="make-payment-btn"
                      @click="handleMakePayment(record)"
                    >
                      결제하기
                    </a-button>
                  </div>
                </template>
              </template>
            </a-table>
            
            <div class="no-result-container" v-show="!loading && subscriptionList.length === 0">
              <i class="fa-solid fa-exclamation-triangle" />
              <span>등록된 구독이 없습니다.</span>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 페이지네이션 -->
      <pagination
        v-if="subscriptionList.length > 0"
        :page-info="{
          listSize: totalItems,
          rowsPerPage: pageSize,
          currentPage: currentPage,
          totalPages: Math.ceil(totalItems / pageSize)
        }"
        page-name="CenterflowSubscriptionList"
        @change-page="(childPassParam) => {
          currentPage = childPassParam.page;
          loadData();
        }"
      />
    </a-col>
    <a-col :span="1"></a-col>
  </a-row>
  
  <!-- 결제내역 모달 -->
  <payment-history-modal
    v-model:visible="showPaymentHistoryModal"
    :subscription="selectedPaymentSubscription"
    @close="showPaymentHistoryModal = false"
  />

  <!-- 일할계산 모달 -->
  <daily-rate-modal
    v-model:visible="showDailyRateModal"
    :subscription="selectedSubscription"
    @close="showDailyRateModal = false"
  />
  
  <!-- 카드 관리 모달 -->
  <card-management-modal
    v-model:visible="showCardModal"
    :subscription="selectedCardSubscription"
    @card-updated="handleCardUpdated"
  />
</template>

<script>
import { ref, reactive, onMounted, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router';
import dayjs from 'dayjs';
import salesRecordsApis from './api';
import DailyRateModal from './DailyRateModal.vue';
import CardManagementModal from './CardManagementModal.vue';
import PaymentHistoryModal from './PaymentHistoryModal.vue';
import { twoBtnDialog } from '@/utils/utils';
import Pagination from "@/views/components/Pagination.vue";

export default {
  name: "CenterflowSubscriptionList",
  components: {
    DailyRateModal,
    CardManagementModal,
    PaymentHistoryModal,
    Pagination
  },
  setup() {
    const router = useRouter();
    const loading = ref(false);
    const currentPage = ref(1);
    const pageSize = ref(10);
    const totalItems = ref(0);
    const dateRange = ref([]);
    const internalInstance = getCurrentInstance();
    const globalProperties = internalInstance?.appContext.config.globalProperties;
    
    // 검색 매개변수
    const searchParams = reactive({
      hospitalName: '',
      status: '',
      hospitalType: '',
      startDate: null,
      endDate: null
    });
    
    // 토스트 메시지 표시 함수
    const showToast = (type, message) => {
      if (globalProperties?.$message) {
        globalProperties.$message[type](message);
      } else {
        alert(message);
      }
    };
    
    // 테이블 열 정의
    const columns = [
      { title: '번호', dataIndex: 'index', key: 'index', align: 'center', width: 70 },
      { title: '병원명', dataIndex: 'hospitalName', key: 'hospitalName', align: 'center', width: 150 },
      { title: '병원 유형', dataIndex: 'hospitalType', key: 'hospitalType', align: 'center', width: 100 },
      { title: '상품명', dataIndex: 'productName', key: 'productName', align: 'center', width: 150 },
      { title: '설치비', dataIndex: 'price', key: 'price', align: 'right', width: 120 },
      { title: '판매가(VAT제외)', dataIndex: 'priceExcludingVAT', key: 'priceExcludingVAT', align: 'right', width: 150 },
      { title: '판매가(VAT포함)', dataIndex: 'priceIncludingVAT', key: 'priceIncludingVAT', align: 'right', width: 150 },
      { title: '계약 시작일', dataIndex: 'contractStartDate', key: 'contractStartDate', align: 'center', width: 120 },
      { title: '계약 종료일', dataIndex: 'contractEndDate', key: 'contractEndDate', align: 'center', width: 120 },
      { title: '결제 예정일', dataIndex: 'paymentDueDate', key: 'paymentDueDate', align: 'center', width: 120 },
      { title: '결제카드', dataIndex: 'paymentCard', key: 'paymentCard', align: 'center', width: 150 },
      { title: '결제내역', dataIndex: 'paymentHistory', key: 'paymentHistory', align: 'center', width: 120 },
      { title: '결제하기', dataIndex: 'makePayment', key: 'makePayment', align: 'center', width: 120 },
      { title: '담당자', dataIndex: 'managerName', key: 'managerName', align: 'center', width: 100 },
      { title: '연락처', dataIndex: 'managerContact', key: 'managerContact', align: 'center', width: 130 },
      { title: '상태', dataIndex: 'status', key: 'status', align: 'center', width: 100 }
    ];
    
    // 구독 목록
    const subscriptionList = ref([]);
    
    // API 인스턴스 가져오기
    const apiHandler = () => {
      return salesRecordsApis(globalProperties?.$apiInstance, globalProperties?.$store);
    };
    
    // 데이터 로드 함수
    const loadData = () => {
      loading.value = true;
      
      const params = {
        page: currentPage.value,
        limit: pageSize.value,
        ...searchParams
      };
      
      apiHandler().getCenterflowSubscriptions(
        params,
        (response) => {
          const { docs, totalDocs } = response.data;
          
          // 데이터 가공 및 인덱스 추가
          subscriptionList.value = docs.map((item, index) => ({
            ...item,
            key: item.id,
            index: (currentPage.value - 1) * pageSize.value + index + 1
          }));
          
          totalItems.value = totalDocs;
          loading.value = false;
        },
        (error) => {
          console.error('구독 목록 로드 에러:', error);
          loading.value = false;
          showToast('error', '구독 목록을 불러오는데 실패했습니다.');
        }
      );
    };
    
    // 검색 함수
    const searchSubscriptions = () => {
      currentPage.value = 1;
      
      if (dateRange.value && dateRange.value.length === 2) {
        searchParams.startDate = dateRange.value[0]?.format('YYYY-MM-DD') || null;
        searchParams.endDate = dateRange.value[1]?.format('YYYY-MM-DD') || null;
      } else {
        searchParams.startDate = null;
        searchParams.endDate = null;
      }
      
      loadData();
    };
    
    // 검색 초기화
    const resetSearch = () => {
      searchParams.hospitalName = '';
      searchParams.status = '';
      searchParams.hospitalType = '';
      dateRange.value = [];
      searchParams.startDate = null;
      searchParams.endDate = null;
      
      loadData();
    };
    
    // 페이지 변경 핸들러
    const handlePageChange = (page) => {
      currentPage.value = page;
      loadData();
    };
    
    // 페이지 크기 변경 핸들러
    const handlePageSizeChange = (size) => {
      pageSize.value = size;
      currentPage.value = 1;
      loadData();
    };
    
    // 구독 추가 페이지로 이동
    const navigateToAddSubscription = () => {
      router.push('/salesrecords/centerflow-subscription/create');
    };
    
    // 구독 편집 핸들러
    const handleEditSubscription = (record) => {
      router.push(`/salesrecords/centerflow-subscription/${record.id}/edit`);
    };
    
    // 구독 삭제 핸들러
    const handleDeleteSubscription = (record) => {
      // 확인 대화상자 표시
      if (window.confirm(`"${record.hospitalName}"의 구독을 삭제하시겠습니까?`)) {
        apiHandler().deleteCenterflowSubscription(
          record.id,
          (response) => {
            showToast('success', '구독이 성공적으로 삭제되었습니다.');
            loadData();
          },
          (error) => {
            showToast('error', '구독 삭제에 실패했습니다.');
          }
        );
      }
    };
    
    // 날짜 형식화 함수
    const formatDate = (timestamp) => {
      if (!timestamp) return '-';
      return dayjs(timestamp).format('YYYY-MM-DD');
    };
    
    // 상태에 따른 색상 가져오기
    const getStatusColor = (status) => {
      switch (status) {
        case 'ACTIVE': return 'green';
        case 'EXPIRED': return 'red';
        case 'PENDING': return 'orange';
        case 'CANCELED': return 'gray';
        case 'SUSPENDED': return 'purple';
        default: return 'default';
      }
    };
    
    // 상태 텍스트 가져오기
    const getStatusText = (status) => {
      switch (status) {
        case 'ACTIVE': return '활성';
        case 'EXPIRED': return '만료';
        case 'PENDING': return '대기';
        case 'CANCELED': return '취소';
        case 'SUSPENDED': return '정지';
        default: return '-';
      }
    };
    
    // 병원 유형 텍스트 가져오기
    const getHospitalTypeText = (type) => {
      switch (type) {
        case 'DENT': return '치과';
        case 'OS': return '정형외과';
        case 'OPH': return '안과';
        default: return '-';
      }
    };
    
    // 연락처 포맷팅 함수
    const formatMobileNumber = (value) => {
      if (!value) return '-';
      if (value.includes('-')) return value;
      
      const numbers = value.replace(/\D/g, '');
      if (!numbers) return '-';
      
      let formattedValue = numbers.slice(0, 3);
        
        if (numbers.length > 3) {
          const isFormat344 = numbers.startsWith('010');
          const secondGroupLength = isFormat344 ? 4 : 3;
          
          formattedValue += '-' + numbers.slice(3, 3 + secondGroupLength);
          
          if (numbers.length > 3 + secondGroupLength) {
            formattedValue += '-' + numbers.slice(3 + secondGroupLength, 3 + secondGroupLength + 4);
        }
      }
      
      return formattedValue || value;
    };
    
    // 활성화된 카드의 카드사 정보 가져오기
    const getActiveCardCompany = (record) => {
      if (!record.cardInfos || record.cardInfos.length === 0) {
        return '-';
      }
      
      const defaultActiveCard = record.cardInfos.find(card => card.isActive && card.isDefault);
      const activeCard = defaultActiveCard || record.cardInfos.find(card => card.isActive);
      
      return activeCard ? (activeCard.cardCompany || '-') : '-';
    };
    
    // 카드 관리 모달 관련 상태
    const showCardModal = ref(false);
    const selectedCardSubscription = ref({});
    
    // 카드 관리 버튼 클릭 핸들러
    const handleManageCard = (record) => {
      selectedCardSubscription.value = { ...record };
      showCardModal.value = true;
    };
    
    // 카드 업데이트 핸들러
    const handleCardUpdated = () => {
      loadData();
    };
    
    // 일할계산 모달 관련 상태
    const showDailyRateModal = ref(false);
    const selectedSubscription = ref({});
    
    // 일할계산 버튼 클릭 핸들러
    const handleDayCalculation = (record) => {
      selectedSubscription.value = { ...record };
      showDailyRateModal.value = true;
    };
    
    // 결제내역 모달 관련 상태
    const showPaymentHistoryModal = ref(false);
    const selectedPaymentSubscription = ref({});
    
    // 결제내역 보기 버튼 클릭 핸들러
    const handleViewPaymentHistory = (record) => {
      selectedPaymentSubscription.value = { ...record };
      showPaymentHistoryModal.value = true;
    };
    
    // 결제하기 버튼 클릭 핸들러
    const handleMakePayment = async (record) => {
      // 결제 예정 정보 가져오기
      const pendingPayments = (record.paymentHistory || [])
        .filter(p => p.paymentStatus === 'PENDING')
        .sort((a, b) => a.paymentRound - b.paymentRound);
      
      // 결제할 내역이 없을 경우
      if (pendingPayments.length === 0) {
        showToast('warning', '결제 예정된 내역이 없습니다.');
        return;
      }
      
      // 결제할 내역 (가장 오래된 PENDING 상태)
      const nextPayment = pendingPayments[0];
      
      // 결제 금액 포맷팅
      const formattedAmount = nextPayment.regularPaymentAmount.toLocaleString() + '원';
      
      // 확인 대화상자 표시
      const confirmResult = await twoBtnDialog(
        '결제 확인',
        `${record.hospitalName}의 ${nextPayment.paymentRound}회차 결제(${formattedAmount})를 진행하시겠습니까?`,
        '결제하기'
      );
      
      // 취소 시 종료
      if (!confirmResult) return;
      
      // API 인스턴스 가져오기
      const api = salesRecordsApis(globalProperties?.$apiInstance, globalProperties?.$store);
      
      try {
        // 결제 API 호출
        await api.processCenterflowPayment(
          record.id,
          {
            paymentRound: nextPayment.paymentRound,
            orderName: `${record.hospitalName} ${nextPayment.paymentRound}회차 정기결제`
          },
          (response) => {
            // API 호출은 성공했지만, 실제 결제 성공 여부 확인
            const paymentResult = response.data;
            
            if (paymentResult.paymentStatus === 'FAILED') {
              // 결제 실패 처리
              const failReason = paymentResult.failReason || '알 수 없는 오류로 결제가 실패했습니다.';
              showToast('error', `결제 실패: ${failReason}`);
            } else if (paymentResult.paymentStatus === 'COMPLETED') {
              // 결제 성공 처리
              showToast('success', '결제가 성공적으로 처리되었습니다.');
            } else {
              // 기타 상태 처리
              showToast('warning', `결제 상태: ${paymentResult.paymentStatus}`);
            }
            
            // 데이터 갱신
            loadData();
          },
          (error) => {
            // API 호출 자체 실패 처리
            const errorMessage = error.response?.data?.message || '결제 처리 중 오류가 발생했습니다.';
            showToast('error', errorMessage);
          }
        );
      } catch (error) {
        showToast('error', '결제 처리 중 예기치 않은 오류가 발생했습니다.');
      }
    };
    
    onMounted(() => {
      loadData();
    });
    
    return {
      loading,
      currentPage,
      pageSize,
      totalItems,
      searchParams,
      dateRange,
      columns,
      subscriptionList,
      searchSubscriptions,
      resetSearch,
      handlePageChange,
      handlePageSizeChange,
      navigateToAddSubscription,
      handleEditSubscription,
      handleDeleteSubscription,
      formatDate,
      getStatusColor,
      getStatusText,
      getHospitalTypeText,
      formatMobileNumber,
      handleManageCard,
      handleViewPaymentHistory,
      handleMakePayment,
      handleDayCalculation,
      showDailyRateModal,
      selectedSubscription,
      getActiveCardCompany,
      showCardModal,
      selectedCardSubscription,
      handleCardUpdated,
      showPaymentHistoryModal,
      selectedPaymentSubscription,
      loadData
    };
  }
};
</script>

<style scoped lang="scss">
.title {
  color: #000;
  font-weight: 700;
  font-size: 24px;
  margin-bottom: 5px;
}

.desc {
  color: #6c757d;
  font-size: 14px;
  font-weight: 400;
  margin-top: 4px;
}

.titleContainer {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.search-filter-container {
  padding: 20px;
  border-bottom: 1px solid #f0f0f0;
  border-radius: 12px;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  margin-bottom: 24px;
}

.search-filter-row {
  display: flex;
  padding: 8px 0;
  min-height: 50px;
  align-items: center;
}

.search-filter-title {
  width: 120px;
  display: flex;
  align-items: center;
  font-weight: 500;
}

.search-filter-content {
  display: flex;
  flex: 1;
  gap: 8px;
  align-items: center;
}

.mobile-wrap {
  display: flex;
  gap: 8px;
}

.date-range-picker {
  width: 250px;
}

.search-btn-filter, .init-btn {
  padding: 4px 15px;
  height: 32px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.search-btn-filter {
  background-color: #1890ff;
  color: white;
  border: 1px solid #1890ff;
  
  &:hover {
    background-color: #40a9ff;
    border-color: #40a9ff;
  }
}

.init-btn {
  background-color: white;
  color: rgba(0, 0, 0, 0.65);
  border: 1px solid #d9d9d9;
  
  &:hover {
    color: #40a9ff;
    border-color: #40a9ff;
  }
}

.table-info-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
}

.total-div {
  p {
    margin: 0;
    font-size: 14px;
    
    .number-highlight {
      color: #1890ff;
      font-weight: bold;
      margin: 0 4px;
    }
  }
}

.search-container {
  display: flex;
  gap: 8px;
  align-items: center;
}

.tableCard {
  border-radius: 12px;
  overflow: hidden;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}

.table-responsive {
  position: relative;
  overflow-x: auto;
}

.table-relative {
  position: relative;
  min-height: 200px;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-left-color: #1890ff;
  animation: spin 1s linear infinite;
}

.table-spinner-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 1;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.no-result-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  color: #999;
  
  i {
    font-size: 24px;
    margin-bottom: 10px;
  }
}

.card-manage-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.card-company {
  font-weight: 500;
  display: block;
  margin-bottom: 4px;
}

.button-cell-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
  height: auto;
}

.card-manage-btn,
.payment-history-btn,
.make-payment-btn,
.day-calc-btn {
  background-color: #f0f0f0;
  border-color: #d9d9d9;
  color: #333;
  margin: 0 !important;
  padding: 0 8px !important;
  height: 24px !important;
  line-height: 22px !important;
  font-size: 12px !important;
  
  &:hover {
    background-color: #e6e6e6;
    border-color: #c0c0c0;
    color: #000;
  }
}

.date-with-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

:deep(.yellow-button) {
  background-color: #FFCC32 !important;
  border-color: #FFCC32 !important;
  color: #000 !important;
  
  &:hover {
    background-color: #E6B82E !important;
    border-color: #E6B82E !important;
  }
  
  &:disabled {
    background-color: #d9d9d9 !important;
    border-color: #d9d9d9 !important;
    color: rgba(0, 0, 0, 0.25) !important;
  }
}

:deep(.ant-table-cell) {
  &[align="center"] {
    text-align: center !important;
    padding: 4px !important;
    vertical-align: middle !important;
  }
}

:deep(.ant-table-tbody > tr > td) {
  transition: none !important;
  padding: 4px 8px !important;
}

@media screen and (max-width: 767px) {
  .search-filter-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .search-filter-title {
    width: 100%;
    margin-bottom: 4px;
  }
  
  .search-filter-content {
    width: 100%;
  }
  
  .date-range-picker {
    width: 100%;
  }
  
  .mobile-wrap {
    width: 100%;
  }
  
  .table-info-filter {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .search-container {
    width: 100%;
    justify-content: space-between;
  }
  
  .search-select {
    width: 120px;
  }
  
  .is-desktop-tablet {
    display: none;
  }
}

@media screen and (min-width: 768px) {
  .is-mobile-only {
    display: none;
  }
}
</style>
